import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_USERS } from '../action-types'

const cleanupCommonFetchUsers = createAction(COMMON_FETCH_USERS.CLEANUP)

export default cleanupCommonFetchUsers
